module.exports = __webpack_public_path__ + "static/kettles-overview-d0f68b59977ff841166dc64c4a9e58c6.jpg";